module.exports = "/_next/static/chromiums/twitter-512x512-products-very-cherry-lip-balm-09e38c854be19ef8ab1706763c920482.jpg";